"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _orderEntryFormConstants = require("../../constants/sendOrder/orderEntryFormConstants");
var _numberFormatter = require("../../helpers/numberFormatter");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _orderHelper = require("../../helpers/orderHelper");
require("./ConfirmOrderModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-order-modal');
var ConfirmOrderModalComponent = function ConfirmOrderModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var formObj = props.formObj,
    isOpen = props.isOpen,
    close = props.close,
    confirmReport = props.confirmReport,
    feeSymbol = props.feeSymbol,
    selectedInstrument = props.selectedInstrument,
    price = props.price,
    orderTotal = props.orderTotal,
    isMarginActive = props.isMarginActive,
    level1 = props.level1,
    leverage = props.leverage;
  var QuantityIncrement = selectedInstrument.QuantityIncrement,
    PriceIncrement = selectedInstrument.PriceIncrement,
    Product1Symbol = selectedInstrument.Product1Symbol,
    Product2Symbol = selectedInstrument.Product2Symbol;
  var isBuySide = formObj.values.side === _orderEntryFormConstants.buyValue;
  var isMarketByValue = formObj.values.anchoredField === 'value';
  var items = [{
    label: "".concat(t('Order Type'), ":"),
    text: formObj.values.orderType
  }, {
    label: "".concat(t('Quantity'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.quantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(QuantityIncrement)), " ").concat(Product1Symbol)
  }, {
    label: formObj.values.orderType === 'Stop Market' || formObj.values.orderType === 'Stop Limit' ? "".concat(t('Stop Price'), ":") : "".concat(t('Price'), ":"),
    text: isMarginActive && formObj.values.orderType === 'Market Order' ? 'Market' : "".concat((0, _numberFormatter.formatNumberToLocale)(price, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)), " ").concat(Product2Symbol)
  }, formObj.values.orderType === 'Stop Limit' && {
    label: "".concat(t('Limit Price'), ":"),
    text: isMarginActive && formObj.values.orderType === 'Market Order' ? 'Market' : "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.limitPrice, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)), " ").concat(Product2Symbol)
  }, {
    label: "".concat(t('Fee'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(formObj.values.fee.OrderFee, feeSymbol), " ").concat(feeSymbol)
  }, isMarketByValue && formObj.values.side === '0' || isMarginActive && formObj.values.orderType === 'Market Order' || isMarginActive && formObj.values.orderType === 'Limit Order' ? null : {
    label: "".concat(t('Value'), ":"),
    text: "".concat((0, _numberFormatter.formatNumberToLocale)(orderTotal, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)), " ").concat(Product2Symbol)
  }];
  if (isMarginActive) {
    if (formObj.values.orderType === 'Stop Market') {
      items.splice(1, 0, {
        label: "".concat(t('Leverage', {
          ns: 'margin'
        }), ":"),
        text: "".concat(leverage, "x")
      });
    } else {
      items.push({
        label: "".concat(t('Net Receiving', {
          ns: 'margin'
        }), ":"),
        text: "".concat((0, _orderHelper.getOrderNet)(formObj.values, selectedInstrument, orderTotal, formObj.values.anchoredField, level1, true, isMarginActive))
      }, {
        label: "".concat(t('Order Total', {
          ns: 'margin'
        }), ":"),
        text: "".concat((0, _numberFormatter.formatNumberToLocale)(orderTotal, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(PriceIncrement)), " ").concat(Product2Symbol)
      });
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: isBuySide ? t('Confirm Buy Order') : t('Confirm Sell Order'),
    close: close,
    footer: {
      buttonText: t('Submit'),
      buttonStyle: isBuySide ? 'additive' : 'subtractive',
      onClick: function onClick() {
        return confirmReport(formObj.values);
      }
    },
    customClass: bemClasses(formObj.values.side === _orderEntryFormConstants.buyValue ? 'bought' : 'sold')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, items.filter(function (i) {
    return i;
  }).map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  })));
};
var _default = exports["default"] = ConfirmOrderModalComponent;